const ASSET_LOCATIONS_TABLE_READY = "assetLocations-table-ready"
const SEARCH_TEXT_STATE = "assetLocations-table-search-text-state"
const ROWS_PER_PAGE_STATE = "assetLocations-table-rows-per-page-state"
const PAGINATION_STATE = "assetLocations-table-pagination-state"

const ASSET_LOCATION_ID_FOR_ACTION = "assetLocations-table-assetLocation-id-for-action"

const ADD_EDIT_ASSET_LOCATION_READY = "add-edit-assetLocation-ready"


const PREVIOUS_ASSET_LOCATION_FILTER_STATUS = "previous-assetLocation-filter-status-action"

const PREVIOUS_ASSET_LOCATION_FILTER_GROUP_ID = "previous-assetLocation-filter-group-id-action"



const initialState = {
    isAssetLocationsTableReady: true,
    isAddEditAssetLocationReady:true,
    assetLocations: {},

    
    assetLocationSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterStatus : "",
    previousFilterGroupId : "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ASSET_LOCATIONS_TABLE_READY:
            return Object.assign({}, state, { isAssetLocationsTableReady: action.payload })
        case ADD_EDIT_ASSET_LOCATION_READY:
            return Object.assign({}, state, { isAddEditAssetLocationReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ASSET_LOCATION_ID_FOR_ACTION:
            return Object.assign({}, state, {assetLocationSelectedId:action.payload})

        case PREVIOUS_ASSET_LOCATION_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})

        case PREVIOUS_ASSET_LOCATION_FILTER_GROUP_ID:
            return Object.assign({}, state, {previousFilterGroupId:action.payload})

        default:
        return state
    
    }

}

export function assetLocationsTableReady(data) {
    return {
        type: ASSET_LOCATIONS_TABLE_READY,
        payload: data
    }
}


export function addEditAssetLocationReady(data) {
    return {
        type: ADD_EDIT_ASSET_LOCATION_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function assetLocationIdForAction(assetLocationId){
    return{
        type:ASSET_LOCATION_ID_FOR_ACTION,
        payload:assetLocationId
    }
}

export function previousFilterStatus(filterVal){
    return{
        type:PREVIOUS_ASSET_LOCATION_FILTER_STATUS,
        payload:filterVal
    }
}


export function previousFilterGroupId(filterVal){
    return{
        type:PREVIOUS_ASSET_LOCATION_FILTER_GROUP_ID,
        payload:filterVal
    }
}




// WEBPACK FOOTER //
// ./src/modules/Asset Locations/redux/assetLocations.js